export default __webpack_public_path__ + "alberta-edit.49768c7ad1297d9c1986.svg";